import { useEffect } from "react";
import { useUser } from "@clerk/nextjs";
import InputWrapper from "../InputWrapper/InputWrapper";

export default function EmailInput({
  id,
  label,
  defaultValue,
  register,
  formState,
  attributes,
  useFormMethods,
  wrapperProps,
}) {
  const { errors } = formState;

  const { isSignedIn, isLoaded, user } = useUser();

  const autoFillValue =
    isSignedIn && isLoaded ? user?.primaryEmailAddress?.emailAddress : null;

  useEffect(() => {
    if (defaultValue || (autoFillValue && useFormMethods)) {
      const { setValue } = useFormMethods;
      setValue(id, autoFillValue);
    }
  }, [defaultValue, useFormMethods, autoFillValue, id]);

  if (!id || !label || !register || !formState) {
    return <p>Could not load this field</p>;
  }

  return (
    <InputWrapper label={label} id={id} formState={formState} {...wrapperProps}>
      <input
        type="email"
        id={id}
        name={id}
        defaultValue={defaultValue ?? autoFillValue}
        className={`textInput`}
        {...attributes}
        {...register(id, {
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          },
        })}
        aria-invalid={errors[id] ? "true" : "false"}
      />
    </InputWrapper>
  );
}
